export const stringConstants = {
  taskCardStrings: {
    completedLevelUpText: "Level up!",
    completedExperientialHoverText:
      "You got an appreciation by the teacher for this homework.",
    completedExperientialPlainText:
      "Your teacher assigned an experiential learning homework. Get hands-on.",
    completedAutoLevelUpText:
      "We have converted your self Learn to levelup homework.",
    completedLevelUpReferenceHoverText:
      "Your teacher wants you to levelup. Let’s try again. ",
    completedLevelUpReferencePlainText:
      "Your teacher wants you to levelup. Let's try again. ",
    completedAppreciationHoverText:
      "You got an appreciation by the teacher for this homework.",
    completedAppreciationPlainText:
      "You got an appreciation by the teacher for this homework.",
    completedCustomAssessmentText: "Teacher has assigned a multi-subtopic",
    chapterEndAssessment: "Chapter End Assessment",
    completedPlainText: "The homework has been completed.",
    pendingExperientialHoverText:
      "Your teacher assigned an experiential learning homework. Get hands-on.",
    pendingExperientialPlainText:
      "Your teacher assigned an experiential learning homework. Get hands-on.",
    pendingAutoLevelUpText:
      "We have converted your self Learn to levelup homework.",
    pendingLevelUpReferencePlainText:
      "Your teacher wants you to levelup. Let's try again. ",
    reminderHoverText: "Your teacher has sent a reminder for completion.",
    pendingPlainText: "Your teacher has assigned a homework on",
    pendingCustomAssessmentText: "Teacher has assigned a multi-subtopic",
    chapterEndAssessmentTaskCard:
      "Your teacher has assigned you a Chapter End Assessment.",
  },
  accordionStrings: {
    defaultCustomAssessmentText: "Teacher unlocked this Assessment.",
  },
};
